<script lang="ts">
    import type {TabGroup} from '../types';
    import {Flex} from 'shared/layouts';
    import {getTabPagesMenuContext} from './tab-pages-menu.context';
    import {getInjector} from 'src/core';
    import {exists} from 'shared/utils/custom-utils';
    import {ErpFondPermissionsContextService, type FondPermissions} from 'src/features/erp';
    import TabButton from './TabButton.svelte';

    const {tabGroups$} = getTabPagesMenuContext();
    const {fondPermissions$} = getInjector().getByClass(ErpFondPermissionsContextService);

    $: filteredTabGroups = filterTabGroupsByPermissions($fondPermissions$, $tabGroups$);

    function filterTabGroupsByPermissions(permissions: FondPermissions, tabGroups: TabGroup[]): TabGroup[] {
        return tabGroups.filter((group) => {
            const filteredSubtabs = (group.subtabs ?? []).filter((subtab) => {
                if (!exists(subtab.permissionFondId)) return true;
                return permissions.editable.includes(subtab.permissionFondId);
            });

            if (!exists(group.permissionFondId) && filteredSubtabs.length === 0) return true;
            return permissions.editable.includes(group.permissionFondId) || filteredSubtabs.length > 0;
        });
    }
</script>

<Flex direction="row" wrap="wrap" alignItems="center" gap="s">
    {#each filteredTabGroups as tabGroup (tabGroup.id)}
        <TabButton {tabGroup}/>
    {/each}
</Flex>
